import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-window-app-dev',
  templateUrl: './window-app-dev.component.html',
  styleUrls: ['./window-app-dev.component.css']
})
export class WindowAppDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/window-app-dev/window-app-dev.component.ts